module.exports = __webpack_public_path__ + "static/media/plus.c32d3fa4.png";